import {
  Component,
  OnInit,
  ViewContainerRef,
  ViewChild,
  ElementRef,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { PlaceType } from '../../../components/hub/place.category/customize.place.category.component';
import { VisitorDataCache } from '../../../stores/visitor.calendar.store';
import { MatMenuTrigger } from '@angular/material';

@Component({
  selector: 'ig-nested-menus',
  templateUrl: './nested.menu.component.html',
  styleUrls: ['./nested.menu.component.scss'],
})
export class NestedMenusComponent implements OnInit {
  constructor() {}

  public topLevelMenuId = '';

  public isFiltering = false;
  public title = '';

  @Input() items: PlaceType[] = [];
  @Input() useNonLeafMenuClick: boolean = false;
  @Output() onClick: EventEmitter<PlaceType | string> = new EventEmitter<PlaceType | string>();
  @Output() onNonLeafClick: EventEmitter<PlaceType | string> = new EventEmitter<PlaceType | string>();
  @ViewChild('trigger') trigger: MatMenuTrigger;

  ngOnInit() {}

  public select(item?: PlaceType | string) {
    this.onClick.emit(item);
    this.trigger.closeMenu();
  }

  public menuOpened($event) {
    setTimeout(() => {
      // the next sibling of backdrop is the 1st level menu
      const backdrop = document.querySelector('.cdk-overlay-backdrop');
      if (backdrop && backdrop.nextElementSibling) {
        const baseButton = document.getElementById('filter-place-category');
        if (baseButton) {
          const rect = baseButton.getBoundingClientRect();
          (backdrop.nextElementSibling as HTMLElement).style.top = `${rect.bottom}px`;
          (backdrop.nextElementSibling as HTMLElement).style.width = `${rect.width}px`;
          (backdrop.nextElementSibling as HTMLElement).style.maxWidth = `${rect.width}px`;
        }
      }
    });
  }

  public setFilter(title?: string) {
    this.title = title;
    this.isFiltering = true;
  }

  public clearFilter() {
    this.title = '';
    this.isFiltering = false;
  }

  public nonLeafClick(node: PlaceType) {
    if (this.useNonLeafMenuClick) {
      this.onNonLeafClick.emit(node);
      this.setFilter(node.title);
      this.trigger.closeMenu();
    }
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/nested.menu/nested.menu.component.ts